// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zeFar9etG5U_g8ZaO0Gs{margin-bottom:12px}.PXMJC5ktSAALqHhkjunT{padding:11px 8px 11px 11px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"countrySelect": `zeFar9etG5U_g8ZaO0Gs`,
	"textField": `PXMJC5ktSAALqHhkjunT`
};
export default ___CSS_LOADER_EXPORT___;
